/**
 * `PlaceholderView` — a calm "this section is not built yet" panel
 * for the Metrics and Team destinations (ADR-0140 P1 deferred items).
 *
 * Resists the temptation to mock data. The admin's voice is precise
 * and technical; staff would rather see "not built" than fake numbers.
 */

import { useC } from '../../lib/theme.js';
import { Card } from '../../components/atoms/Card.js';

const serifFont = "'Instrument Serif', serif";
const sansFont = "'Geist', sans-serif";
const monoFont = "'JetBrains Mono', monospace";

export interface PlaceholderViewProps {
  kicker: string;
  title: string;
  body: string;
}

export function PlaceholderView({
  kicker,
  title,
  body,
}: PlaceholderViewProps): JSX.Element {
  const C = useC();
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12">
      <div
        style={{
          fontFamily: monoFont,
          fontSize: 10,
          color: C.muted,
          letterSpacing: 2,
          textTransform: 'uppercase',
          marginBottom: 10,
        }}
      >
        {kicker}
      </div>
      <h1
        style={{
          fontFamily: serifFont,
          fontSize: 'clamp(36px, 6vw, 48px)',
          lineHeight: 1,
          color: C.text,
          letterSpacing: -1.5,
          marginBottom: 28,
        }}
      >
        {title}
      </h1>
      <Card style={{ padding: 24 }}>
        <p
          style={{
            fontFamily: sansFont,
            fontSize: 14,
            color: C.body,
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          {body}
        </p>
      </Card>
    </div>
  );
}
